import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-backed-card',
  templateUrl: './turns-reports-backed-card.component.html',
  styleUrls: ['./turns-reports-backed-card.component.scss']
})
export class TurnsReportsBackedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
